import PromotionInsights from "@/components/promotions/PromotionInsights"

const AdminPromotionAnalytics = () => {
    return <PromotionInsights mode="admin" />
}

export default AdminPromotionAnalytics
